// ── BUSINESS INFO ──────────────────────────────────────────────────
export const BUSINESS = {
  name: 'Brantford Auto Wrecking & Salvage',
  shortName: 'Brantford Auto',
  tagline: 'Quality Used Auto Parts You Can Trust',
  subtagline: 'Affordable, Reliable Parts for All Makes & Models',
  phone: '(519) 774-3338',
  phoneRaw: '5197743338',
  email: 'info@brantfordauto.ca',
  address: {
    street: '44 German School Rd',
    city: 'Paris',
    province: 'ON',
    postal: 'N3L 3E1',
    full: '44 German School Rd, Paris, ON N3L 3E1',
  },
  hours: [
    { day: 'Monday',    open: '8:00 AM', close: '5:00 PM', closed: false },
    { day: 'Tuesday',   open: '8:00 AM', close: '5:00 PM', closed: false },
    { day: 'Wednesday', open: '8:00 AM', close: '5:00 PM', closed: false },
    { day: 'Thursday',  open: '8:00 AM', close: '5:00 PM', closed: false },
    { day: 'Friday',    open: '8:00 AM', close: '5:00 PM', closed: false },
    { day: 'Saturday',  open: '9:00 AM', close: '3:00 PM', closed: false },
    { day: 'Sunday',    open: null,      close: null,       closed: true  },
  ],
  social: {
    facebook: 'https://facebook.com/',
    instagram: 'https://instagram.com/',
    google: 'https://google.com/',
  },
  mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2907.284!2d-80.38!3d43.22!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s44+German+School+Rd%2C+Paris%2C+ON!5e0!3m2!1sen!2sca!4v1',
  stats: [
    { num: '500+', label: 'Vehicles in Yard' },
    { num: '20+',  label: 'Years Experience' },
    { num: 'All',  label: 'Makes & Models' },
  ],
  trustBadges: [
    '✓ Free Parts Search',
    '✓ Warranty Available',
    '✓ Eco-Friendly Recycling',
    '✓ Local & Trusted Since 2000',
  ],
};

// ── SERVICES ────────────────────────────────────────────────────────
export const SERVICES = [
  {
    icon: '🔩',
    title: 'Used Auto Parts Sales',
    description: 'Quality tested used parts for all makes and models at a fraction of new part prices. Every part is inspected before sale.',
    link: '/inventory',
  },
  {
    icon: '♻️',
    title: 'Vehicle Recycling',
    description: 'We responsibly dismantle end-of-life vehicles, recovering usable parts and recycling materials in an environmentally safe manner.',
    link: '/contact',
  },
  {
    icon: '🚗',
    title: 'Scrap Car Removal',
    description: 'Free pickup of your old, damaged or unwanted vehicle. Get cash for your scrap car — we handle all the paperwork.',
    link: '/contact',
  },
  {
    icon: '🔎',
    title: 'Parts Locator Service',
    description: "Can't find the part you need? Our network connects us with salvage yards across Ontario to source hard-to-find parts fast.",
    link: '/request-part',
  },
];

// ── PART CATEGORIES ─────────────────────────────────────────────────
export const CATEGORIES = [
  { icon: '🔧', name: 'Engine Parts',     desc: 'Blocks, heads, manifolds & more',   search: 'Engine' },
  { icon: '⚙️', name: 'Transmission',     desc: 'Auto & manual, transfer cases',      search: 'Transmission' },
  { icon: '🚗', name: 'Body Parts',        desc: 'Doors, hoods, fenders, bumpers',     search: 'Body' },
  { icon: '⚡', name: 'Electrical',        desc: 'Alternators, starters, ECUs',        search: 'Electrical' },
  { icon: '🛞', name: 'Tires & Wheels',   desc: 'Rims, steel & alloy wheels',         search: 'Tires' },
  { icon: '🏎️', name: 'Suspension',       desc: 'Struts, control arms, shocks',       search: 'Suspension' },
  { icon: '🔴', name: 'Brakes',            desc: 'Calipers, rotors, pads',             search: 'Brakes' },
  { icon: '🪑', name: 'Interior',          desc: 'Seats, dashboards, trim pieces',     search: 'Interior' },
  { icon: '❄️', name: 'Cooling System',   desc: 'Radiators, fans, thermostats',       search: 'Cooling' },
  { icon: '💨', name: 'Exhaust',           desc: 'Mufflers, catalytic converters',     search: 'Exhaust' },
];

// ── WHY CHOOSE US ────────────────────────────────────────────────────
export const WHY_ITEMS = [
  {
    icon: '💰',
    title: 'Affordable Prices',
    desc: 'Save 50–80% versus new OEM parts without sacrificing reliability. We believe everyone deserves quality parts at fair prices.',
  },
  {
    icon: '📦',
    title: 'Large Inventory',
    desc: 'Over 500 vehicles on-site spanning all major domestic and import brands. New vehicles added regularly.',
  },
  {
    icon: '⚡',
    title: 'Fast Service',
    desc: 'Same-day pickup available for most parts. Call ahead and we\'ll have it pulled and ready when you arrive.',
  },
  {
    icon: '♻️',
    title: 'Eco-Friendly Recycling',
    desc: 'Fully certified auto recycler. We properly dispose of fluids and hazardous materials, reducing environmental impact.',
  },
];

// ── TESTIMONIALS ──────────────────────────────────────────────────────
export const TESTIMONIALS = [
  {
    stars: 5,
    text: 'Found a transmission for my 2015 F-150 in perfect condition. Priced way better than anywhere else I called. Staff was super helpful and had it pulled in an hour.',
    name: 'Mike R.',
    location: 'Brantford, ON',
    initials: 'MR',
  },
  {
    stars: 5,
    text: "Been going to Brantford Auto for 10 years. Always honest, always fair. They found a door panel for my Civic that I couldn't find anywhere else in Southern Ontario.",
    name: 'Sarah P.',
    location: 'Paris, ON',
    initials: 'SP',
  },
  {
    stars: 5,
    text: 'Called about a specific alternator, they confirmed it was there, had it ready when I came in 30 minutes later. Saved me $280 vs the dealership price. Fantastic service.',
    name: 'Dave K.',
    location: 'Hamilton, ON',
    initials: 'DK',
  },
  {
    stars: 4,
    text: 'Used them for scrap car removal — easy process, fast pickup, got a fair price. The team was professional and took care of all the paperwork. Would definitely recommend.',
    name: 'Tracy L.',
    location: 'Cambridge, ON',
    initials: 'TL',
  },
  {
    stars: 5,
    text: 'As a mechanic I rely on Brantford Auto weekly. Their inventory is massive, the staff know their stuff, and their parts locator service has saved my customers a ton of money.',
    name: 'Jason B.',
    location: 'Auto Mechanic, Brantford',
    initials: 'JB',
  },
  {
    stars: 5,
    text: 'Great local business. Eco-friendly operations, knowledgeable staff, huge selection. Glad to support a company that cares about the community and the environment.',
    name: 'Amanda L.',
    location: 'Brantford, ON',
    initials: 'AL',
  },
];

// ── VEHICLE DATA ──────────────────────────────────────────────────────
export const CURRENT_YEAR = new Date().getFullYear();

export const YEARS = Array.from(
  { length: CURRENT_YEAR + 2 - 1990 },
  (_, i) => CURRENT_YEAR + 1 - i
);

export const MAKE_MODELS = {
  Acura:        ['ILX', 'MDX', 'RDX', 'TL', 'TSX'],
  BMW:          ['3 Series', '5 Series', '7 Series', 'X3', 'X5', 'X7'],
  Buick:        ['Enclave', 'Encore', 'LaCrosse', 'Regal'],
  Cadillac:     ['ATS', 'CT5', 'Escalade', 'SRX', 'XT5'],
  Chevrolet:    ['Camaro', 'Colorado', 'Corvette', 'Cruze', 'Equinox', 'Impala', 'Malibu', 'Silverado', 'Tahoe', 'Traverse'],
  Chrysler:     ['200', '300', 'Pacifica', 'Town & Country'],
  Dodge:        ['Challenger', 'Charger', 'Dart', 'Durango', 'Journey', 'Ram'],
  Ford:         ['Bronco', 'Edge', 'Escape', 'Explorer', 'F-150', 'F-250', 'Focus', 'Fusion', 'Mustang', 'Ranger'],
  GMC:          ['Acadia', 'Canyon', 'Sierra', 'Terrain', 'Yukon'],
  Honda:        ['Accord', 'CR-V', 'Civic', 'Element', 'Fit', 'HR-V', 'Odyssey', 'Pilot', 'Ridgeline'],
  Hyundai:      ['Elantra', 'Santa Fe', 'Sonata', 'Tucson', 'Veloster'],
  Jeep:         ['Cherokee', 'Compass', 'Gladiator', 'Grand Cherokee', 'Renegade', 'Wrangler'],
  Kia:          ['Forte', 'K5', 'Sorento', 'Soul', 'Sportage', 'Stinger', 'Telluride'],
  Mazda:        ['CX-3', 'CX-5', 'CX-9', 'Mazda3', 'Mazda6'],
  'Mercedes-Benz': ['C-Class', 'E-Class', 'GLC', 'GLE', 'S-Class'],
  Nissan:       ['Altima', 'Frontier', 'Maxima', 'Murano', 'Pathfinder', 'Rogue', 'Sentra', 'Titan', 'Versa'],
  RAM:          ['1500', '2500', '3500', 'ProMaster'],
  Subaru:       ['Crosstrek', 'Forester', 'Impreza', 'Legacy', 'Outback', 'WRX'],
  Toyota:       ['4Runner', 'Camry', 'Corolla', 'Highlander', 'RAV4', 'Sienna', 'Tacoma', 'Tundra', 'Venza'],
  Volkswagen:   ['Atlas', 'Golf', 'Jetta', 'Passat', 'Tiguan'],
  Volvo:        ['S60', 'S90', 'XC40', 'XC60', 'XC90'],
};

export const PART_CATEGORIES_LIST = [
  'All Parts',
  'Engine',
  'Transmission',
  'Body Parts',
  'Electrical',
  'Tires & Wheels',
  'Suspension',
  'Brakes',
  'Cooling System',
  'Interior',
  'Exhaust',
];

// ── NAV LINKS ─────────────────────────────────────────────────────────
export const NAV_LINKS = [
  { label: 'Parts Search', href: '/inventory' },
  { label: 'Services',     href: '/#services' },
  { label: 'Inventory',    href: '/inventory' },
  { label: 'About Us',     href: '/about' },
  { label: 'Contact',      href: '/contact' },
];
